import * as React from "react";
import {
    Box, Card, Chip, Container, IconButton, InputAdornment, TextField, Typography,
} from "@mui/material";
import ButtonComponent from "components/Button";
import TextFieldComponent from "components/TextField";
import {
     getButtonDataCancel,
} from "./helper";
import { getLocalDate, getImage } from "helpers/utils";


import {useState} from "react";
import ShareIcon from "@mui/icons-material/Share";
import MailIcon from "@mui/icons-material/Mail";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import {EmailShareButton, FacebookShareButton, TwitterShareButton, WhatsappShareButton} from "react-share";
import AddBoxSharpIcon from "@mui/material/SvgIcon/SvgIcon";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";


const ShopProductDetail = ({
   selectedProduct, currency, onAddToWishlistClicked, onAddToCartClicked, messageShopClicked, onCancel, productdetail,
}) => {

    const [state, setState] = useState({});
    const [share, setShare] = useState(false);

    const {
     created_at: createdAt, _id: _id, status, message
  } = selectedProduct || {};


    const handleShare = () => {
        setShare(!share);
    };


    const renderProductInformation = () => (
        <Box p={2} width="100%" display="flex">
            <Box width="50%">
                <Typography className="styled-link" variant="subtitle2">
                    {` Id: ${_id}`}
                </Typography>
            </Box>
            <Box width="50%">
                <Typography className="styled-link" align="right" display="block" variant="subtitle2">
                    Date:
                    {" "}
                    {getLocalDate(createdAt)}
                </Typography>
                <IconButton size="small" onClick={onAddToWishlistClicked}>
                    <FavoriteBorderIcon color="secondary" />
                </IconButton>
                <IconButton className="setting-button" color="primary" size="small" onClick={onAddToCartClicked}>
                    <AddBoxSharpIcon />
                </IconButton>
            </Box>
        </Box>
    );


    return (
        <Container>
            <Container maxWidth="md">
                <Container className="header-color">
                    {renderProductInformation()}
                </Container>
                <Box mb={2}>
                    {
                        getButtonDataCancel(onCancel).map((element) => (
                            <ButtonComponent
                                sx={{
                                    m: 2,
                                }}
                                type={element.type}
                                variant={element.variant}
                                onClick={element.onClick}
                                disabled={element.disabled}
                                name={element.name}
                            />
                        ))
                    }
                </Box>
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content quick-view-modal">
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-6  col-xs-12">
                                    <div className="quick-view-img">
                                        <img src={getImage(productdetail.images)} alt="" className="img-fluid" />
                                    </div>
                                </div>
                                <div className="col-lg-6 rtl-text">
                                    <div className="product-right">
                                        <Typography variant="h2">
                                            {productdetail.name}
                                        </Typography>
                                        <div className="border-product">
                                            <Typography variant="h6">Product Details</Typography>
                                            <Typography>{productdetail.shortDetails}</Typography>
                                        </div>
                                        <Typography align="right">
                                            <IconButton onClick={handleShare} size="large">
                                                <ShareIcon />
                                            </IconButton>
                                        </Typography>
                                        {
                                            share && (
                                                <>
                                                    <EmailShareButton url={window.location.href}>
                                                        <IconButton size="small">
                                                            <MailIcon />
                                                        </IconButton>
                                                    </EmailShareButton>
                                                    <FacebookShareButton url={window.location.href}>
                                                        <IconButton size="small">
                                                            <FacebookIcon />
                                                        </IconButton>
                                                    </FacebookShareButton>
                                                    <TwitterShareButton url={window.location.href}>
                                                        <IconButton size="small">
                                                            <TwitterIcon />
                                                        </IconButton>
                                                    </TwitterShareButton>
                                                    <WhatsappShareButton url={"www.shopana.in"}
                                                                         title={"Check with us!"}>
                                                        <IconButton size="small">
                                                            <WhatsAppIcon />
                                                        </IconButton>
                                                    </WhatsappShareButton>
                                                </>
                                            )
                                        }
                                        <Box className="product-buttons">
                                            <button className="btn m-2 btn-solid" type="button" onClick={() => onAddToCartClicked(productdetail._id, 1)}>add to cart</button>
                                        </Box>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </Container>
    );
};

export default ShopProductDetail;
